import { MainTemplate } from "@/components/templates";
import {
  BizsolProvisionalRegistrationForm,
  BizsolProvisionalRegistrationFormValues,
} from "@/components/organisms";
import {
  RegisterProvisionalCompanyWithBizsolMutation,
  useRegisterProvisionalCompanyWithBizsolMutation,
} from "@/generated/graphql";
import React from "react";
import { useRouter } from "next/router";
import { PageTitle } from "@/components/molecules";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const BizsolProvisionalRegistrationPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();
  const { app, code } = router.query;

  const [registerProvisionalCompanyUserWithBizsolMutation] =
    useRegisterProvisionalCompanyWithBizsolMutation({
      onCompleted: (data: RegisterProvisionalCompanyWithBizsolMutation) => {
        if (data.registerProvisionalCompanyWithBizsol) {
          router.push("/bizsol/provisional-registration-result");
        }
      },
      onError: getNotifyErrorHandlerForGraphQL(
        "Faild to register provisional company user with bizsol",
        "登録に失敗しました"
      ),
    });

  const handleSubmit = async (
    formValues: BizsolProvisionalRegistrationFormValues
  ) => {
    await registerProvisionalCompanyUserWithBizsolMutation({
      variables: {
        input: {
          email: formValues.email,
          app: app ? String(app) : "",
          registrationCode: code ? String(code) : "",
        },
      },
    });
  };

  return (
    <MainTemplate title="新規登録">
      <PageTitle
        mainTitle={`新規登録`}
        subTitle={
          <>
            Mikatano シリーズの各サービスに共通でログインできるMikatano
            IDを作成します。
            <br />
            メールアドレスを入力し利用規約に同意して登録してください。
          </>
        }
      />
      <BizsolProvisionalRegistrationForm onSubmit={handleSubmit} />
    </MainTemplate>
  );
};
